@file:OptIn(InternalResourceApi::class)

package gero.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/gero.composeapp.generated.resources/"

@delegate:ResourceContentHash(-875_945_947)
internal val Res.drawable.G45: DrawableResource by lazy {
      DrawableResource("drawable:G45", setOf(
        ResourceItem(setOf(), "${MD}drawable/G45.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_049_138_421)
internal val Res.drawable.G45A: DrawableResource by lazy {
      DrawableResource("drawable:G45A", setOf(
        ResourceItem(setOf(), "${MD}drawable/G45A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(434_399_862)
internal val Res.drawable.G46: DrawableResource by lazy {
      DrawableResource("drawable:G46", setOf(
        ResourceItem(setOf(), "${MD}drawable/G46.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(581_984_054)
internal val Res.drawable.G47: DrawableResource by lazy {
      DrawableResource("drawable:G47", setOf(
        ResourceItem(setOf(), "${MD}drawable/G47.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(203_483_094)
internal val Res.drawable.G48: DrawableResource by lazy {
      DrawableResource("drawable:G48", setOf(
        ResourceItem(setOf(), "${MD}drawable/G48.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_841_668_269)
internal val Res.drawable.G49: DrawableResource by lazy {
      DrawableResource("drawable:G49", setOf(
        ResourceItem(setOf(), "${MD}drawable/G49.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_502_176_361)
internal val Res.drawable.G5: DrawableResource by lazy {
      DrawableResource("drawable:G5", setOf(
        ResourceItem(setOf(), "${MD}drawable/G5.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(522_274_148)
internal val Res.drawable.G50: DrawableResource by lazy {
      DrawableResource("drawable:G50", setOf(
        ResourceItem(setOf(), "${MD}drawable/G50.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-706_215_219)
internal val Res.drawable.G51: DrawableResource by lazy {
      DrawableResource("drawable:G51", setOf(
        ResourceItem(setOf(), "${MD}drawable/G51.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_069_552_415)
internal val Res.drawable.G52: DrawableResource by lazy {
      DrawableResource("drawable:G52", setOf(
        ResourceItem(setOf(), "${MD}drawable/G52.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(93_040_627)
internal val Res.drawable.G53: DrawableResource by lazy {
      DrawableResource("drawable:G53", setOf(
        ResourceItem(setOf(), "${MD}drawable/G53.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-231_780_168)
internal val Res.drawable.G54: DrawableResource by lazy {
      DrawableResource("drawable:G54", setOf(
        ResourceItem(setOf(), "${MD}drawable/G54.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_002_098_102)
internal val Res.drawable.G6: DrawableResource by lazy {
      DrawableResource("drawable:G6", setOf(
        ResourceItem(setOf(), "${MD}drawable/G6.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-3_761_573)
internal val Res.drawable.G6A: DrawableResource by lazy {
      DrawableResource("drawable:G6A", setOf(
        ResourceItem(setOf(), "${MD}drawable/G6A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-640_552_552)
internal val Res.drawable.G7: DrawableResource by lazy {
      DrawableResource("drawable:G7", setOf(
        ResourceItem(setOf(), "${MD}drawable/G7.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_732_183_623)
internal val Res.drawable.G7A: DrawableResource by lazy {
      DrawableResource("drawable:G7A", setOf(
        ResourceItem(setOf(), "${MD}drawable/G7A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(223_052_450)
internal val Res.drawable.G7B: DrawableResource by lazy {
      DrawableResource("drawable:G7B", setOf(
        ResourceItem(setOf(), "${MD}drawable/G7B.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-256_192_737)
internal val Res.drawable.G8: DrawableResource by lazy {
      DrawableResource("drawable:G8", setOf(
        ResourceItem(setOf(), "${MD}drawable/G8.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-146_814_492)
internal val Res.drawable.G9: DrawableResource by lazy {
      DrawableResource("drawable:G9", setOf(
        ResourceItem(setOf(), "${MD}drawable/G9.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_660_940_323)
internal val Res.drawable.H1: DrawableResource by lazy {
      DrawableResource("drawable:H1", setOf(
        ResourceItem(setOf(), "${MD}drawable/H1.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_281_484_795)
internal val Res.drawable.H2: DrawableResource by lazy {
      DrawableResource("drawable:H2", setOf(
        ResourceItem(setOf(), "${MD}drawable/H2.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_697_374_038)
internal val Res.drawable.H3: DrawableResource by lazy {
      DrawableResource("drawable:H3", setOf(
        ResourceItem(setOf(), "${MD}drawable/H3.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_987_582_476)
internal val Res.drawable.H4: DrawableResource by lazy {
      DrawableResource("drawable:H4", setOf(
        ResourceItem(setOf(), "${MD}drawable/H4.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(35_778_813)
internal val Res.drawable.H5: DrawableResource by lazy {
      DrawableResource("drawable:H5", setOf(
        ResourceItem(setOf(), "${MD}drawable/H5.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_410_154)
internal val Res.drawable.H6: DrawableResource by lazy {
      DrawableResource("drawable:H6", setOf(
        ResourceItem(setOf(), "${MD}drawable/H6.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_780_185_015)
internal val Res.drawable.H6A: DrawableResource by lazy {
      DrawableResource("drawable:H6A", setOf(
        ResourceItem(setOf(), "${MD}drawable/H6A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(85_038_252)
internal val Res.drawable.H7: DrawableResource by lazy {
      DrawableResource("drawable:H7", setOf(
        ResourceItem(setOf(), "${MD}drawable/H7.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(124_334_191)
internal val Res.drawable.H8: DrawableResource by lazy {
      DrawableResource("drawable:H8", setOf(
        ResourceItem(setOf(), "${MD}drawable/H8.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(168_344_665)
internal val Res.drawable.I1: DrawableResource by lazy {
      DrawableResource("drawable:I1", setOf(
        ResourceItem(setOf(), "${MD}drawable/I1.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-629_927_508)
internal val Res.drawable.I10: DrawableResource by lazy {
      DrawableResource("drawable:I10", setOf(
        ResourceItem(setOf(), "${MD}drawable/I10.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_993_956_233)
internal val Res.drawable.I10A: DrawableResource by lazy {
      DrawableResource("drawable:I10A", setOf(
        ResourceItem(setOf(), "${MD}drawable/I10A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-230_659_405)
internal val Res.drawable.I10X1: DrawableResource by lazy {
      DrawableResource("drawable:I10X1", setOf(
        ResourceItem(setOf(), "${MD}drawable/I10X1.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_121_869_376)
internal val Res.drawable.I11: DrawableResource by lazy {
      DrawableResource("drawable:I11", setOf(
        ResourceItem(setOf(), "${MD}drawable/I11.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_102_572_473)
internal val Res.drawable.I11A: DrawableResource by lazy {
      DrawableResource("drawable:I11A", setOf(
        ResourceItem(setOf(), "${MD}drawable/I11A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_661_262_568)
internal val Res.drawable.I12: DrawableResource by lazy {
      DrawableResource("drawable:I12", setOf(
        ResourceItem(setOf(), "${MD}drawable/I12.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-541_157_313)
internal val Res.drawable.I13: DrawableResource by lazy {
      DrawableResource("drawable:I13", setOf(
        ResourceItem(setOf(), "${MD}drawable/I13.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_144_976_274)
internal val Res.drawable.I14: DrawableResource by lazy {
      DrawableResource("drawable:I14", setOf(
        ResourceItem(setOf(), "${MD}drawable/I14.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-94_400_495)
internal val Res.drawable.I15: DrawableResource by lazy {
      DrawableResource("drawable:I15", setOf(
        ResourceItem(setOf(), "${MD}drawable/I15.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_916_059_326)
internal val Res.drawable.I2: DrawableResource by lazy {
      DrawableResource("drawable:I2", setOf(
        ResourceItem(setOf(), "${MD}drawable/I2.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_161_013_993)
internal val Res.drawable.I3: DrawableResource by lazy {
      DrawableResource("drawable:I3", setOf(
        ResourceItem(setOf(), "${MD}drawable/I3.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-676_119_523)
internal val Res.drawable.I4: DrawableResource by lazy {
      DrawableResource("drawable:I4", setOf(
        ResourceItem(setOf(), "${MD}drawable/I4.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(250_674_404)
internal val Res.drawable.I5: DrawableResource by lazy {
      DrawableResource("drawable:I5", setOf(
        ResourceItem(setOf(), "${MD}drawable/I5.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(482_917_349)
internal val Res.drawable.I5A: DrawableResource by lazy {
      DrawableResource("drawable:I5A", setOf(
        ResourceItem(setOf(), "${MD}drawable/I5A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-27_856_235)
internal val Res.drawable.I6: DrawableResource by lazy {
      DrawableResource("drawable:I6", setOf(
        ResourceItem(setOf(), "${MD}drawable/I6.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-304_323_374)
internal val Res.drawable.I7: DrawableResource by lazy {
      DrawableResource("drawable:I7", setOf(
        ResourceItem(setOf(), "${MD}drawable/I7.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_920_374_655)
internal val Res.drawable.I8: DrawableResource by lazy {
      DrawableResource("drawable:I8", setOf(
        ResourceItem(setOf(), "${MD}drawable/I8.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_441_173_495)
internal val Res.drawable.I9: DrawableResource by lazy {
      DrawableResource("drawable:I9", setOf(
        ResourceItem(setOf(), "${MD}drawable/I9.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_284_553_072)
internal val Res.drawable.I9A: DrawableResource by lazy {
      DrawableResource("drawable:I9A", setOf(
        ResourceItem(setOf(), "${MD}drawable/I9A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(621_541)
internal val Res.drawable.K1: DrawableResource by lazy {
      DrawableResource("drawable:K1", setOf(
        ResourceItem(setOf(), "${MD}drawable/K1.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_719_052_583)
internal val Res.drawable.K2: DrawableResource by lazy {
      DrawableResource("drawable:K2", setOf(
        ResourceItem(setOf(), "${MD}drawable/K2.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-725_035_302)
internal val Res.drawable.K3: DrawableResource by lazy {
      DrawableResource("drawable:K3", setOf(
        ResourceItem(setOf(), "${MD}drawable/K3.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-466_764_192)
internal val Res.drawable.K4: DrawableResource by lazy {
      DrawableResource("drawable:K4", setOf(
        ResourceItem(setOf(), "${MD}drawable/K4.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_077_403_350)
internal val Res.drawable.K5: DrawableResource by lazy {
      DrawableResource("drawable:K5", setOf(
        ResourceItem(setOf(), "${MD}drawable/K5.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-193_564_561)
internal val Res.drawable.K6: DrawableResource by lazy {
      DrawableResource("drawable:K6", setOf(
        ResourceItem(setOf(), "${MD}drawable/K6.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-684_695_346)
internal val Res.drawable.K7: DrawableResource by lazy {
      DrawableResource("drawable:K7", setOf(
        ResourceItem(setOf(), "${MD}drawable/K7.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_836_725_844)
internal val Res.drawable.K8: DrawableResource by lazy {
      DrawableResource("drawable:K8", setOf(
        ResourceItem(setOf(), "${MD}drawable/K8.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_036_260_290)
internal val Res.drawable.L1: DrawableResource by lazy {
      DrawableResource("drawable:L1", setOf(
        ResourceItem(setOf(), "${MD}drawable/L1.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_246_841_911)
internal val Res.drawable.L2: DrawableResource by lazy {
      DrawableResource("drawable:L2", setOf(
        ResourceItem(setOf(), "${MD}drawable/L2.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_490_501_708)
internal val Res.drawable.L2A: DrawableResource by lazy {
      DrawableResource("drawable:L2A", setOf(
        ResourceItem(setOf(), "${MD}drawable/L2A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(899_000_903)
internal val Res.drawable.L3: DrawableResource by lazy {
      DrawableResource("drawable:L3", setOf(
        ResourceItem(setOf(), "${MD}drawable/L3.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-491_973_825)
internal val Res.drawable.L4: DrawableResource by lazy {
      DrawableResource("drawable:L4", setOf(
        ResourceItem(setOf(), "${MD}drawable/L4.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-685_390_740)
internal val Res.drawable.L5: DrawableResource by lazy {
      DrawableResource("drawable:L5", setOf(
        ResourceItem(setOf(), "${MD}drawable/L5.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(379_848_624)
internal val Res.drawable.L6: DrawableResource by lazy {
      DrawableResource("drawable:L6", setOf(
        ResourceItem(setOf(), "${MD}drawable/L6.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_324_963_418)
internal val Res.drawable.L6A: DrawableResource by lazy {
      DrawableResource("drawable:L6A", setOf(
        ResourceItem(setOf(), "${MD}drawable/L6A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_345_758_126)
internal val Res.drawable.L7: DrawableResource by lazy {
      DrawableResource("drawable:L7", setOf(
        ResourceItem(setOf(), "${MD}drawable/L7.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-381_409_086)
internal val Res.drawable.L8: DrawableResource by lazy {
      DrawableResource("drawable:L8", setOf(
        ResourceItem(setOf(), "${MD}drawable/L8.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_174_496_128)
internal val Res.drawable.M1: DrawableResource by lazy {
      DrawableResource("drawable:M1", setOf(
        ResourceItem(setOf(), "${MD}drawable/M1.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_921_271_947)
internal val Res.drawable.M10: DrawableResource by lazy {
      DrawableResource("drawable:M10", setOf(
        ResourceItem(setOf(), "${MD}drawable/M10.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_034_805_797)
internal val Res.drawable.M10A: DrawableResource by lazy {
      DrawableResource("drawable:M10A", setOf(
        ResourceItem(setOf(), "${MD}drawable/M10A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_856_860_895)
internal val Res.drawable.M11: DrawableResource by lazy {
      DrawableResource("drawable:M11", setOf(
        ResourceItem(setOf(), "${MD}drawable/M11.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_340_579_019)
internal val Res.drawable.M12: DrawableResource by lazy {
      DrawableResource("drawable:M12", setOf(
        ResourceItem(setOf(), "${MD}drawable/M12.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(373_439_578)
internal val Res.drawable.M12A: DrawableResource by lazy {
      DrawableResource("drawable:M12A", setOf(
        ResourceItem(setOf(), "${MD}drawable/M12A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_919_981_751)
internal val Res.drawable.M12B: DrawableResource by lazy {
      DrawableResource("drawable:M12B", setOf(
        ResourceItem(setOf(), "${MD}drawable/M12B.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_188_564_363)
internal val Res.drawable.M12C: DrawableResource by lazy {
      DrawableResource("drawable:M12C", setOf(
        ResourceItem(setOf(), "${MD}drawable/M12C.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_520_995_304)
internal val Res.drawable.M12D: DrawableResource by lazy {
      DrawableResource("drawable:M12D", setOf(
        ResourceItem(setOf(), "${MD}drawable/M12D.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_490_457_807)
internal val Res.drawable.M12E: DrawableResource by lazy {
      DrawableResource("drawable:M12E", setOf(
        ResourceItem(setOf(), "${MD}drawable/M12E.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(371_203_705)
internal val Res.drawable.M12F: DrawableResource by lazy {
      DrawableResource("drawable:M12F", setOf(
        ResourceItem(setOf(), "${MD}drawable/M12F.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_022_264_889)
internal val Res.drawable.M12G: DrawableResource by lazy {
      DrawableResource("drawable:M12G", setOf(
        ResourceItem(setOf(), "${MD}drawable/M12G.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_897_381_932)
internal val Res.drawable.M12H: DrawableResource by lazy {
      DrawableResource("drawable:M12H", setOf(
        ResourceItem(setOf(), "${MD}drawable/M12H.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_405_052_355)
internal val Res.drawable.M13: DrawableResource by lazy {
      DrawableResource("drawable:M13", setOf(
        ResourceItem(setOf(), "${MD}drawable/M13.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-264_346_881)
internal val Res.drawable.M14: DrawableResource by lazy {
      DrawableResource("drawable:M14", setOf(
        ResourceItem(setOf(), "${MD}drawable/M14.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_417_741_712)
internal val Res.drawable.M15: DrawableResource by lazy {
      DrawableResource("drawable:M15", setOf(
        ResourceItem(setOf(), "${MD}drawable/M15.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_860_924_675)
internal val Res.drawable.M15A: DrawableResource by lazy {
      DrawableResource("drawable:M15A", setOf(
        ResourceItem(setOf(), "${MD}drawable/M15A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_333_003_352)
internal val Res.drawable.M16: DrawableResource by lazy {
      DrawableResource("drawable:M16", setOf(
        ResourceItem(setOf(), "${MD}drawable/M16.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_410_944_470)
internal val Res.drawable.M16A: DrawableResource by lazy {
      DrawableResource("drawable:M16A", setOf(
        ResourceItem(setOf(), "${MD}drawable/M16A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(542_403_262)
internal val Res.drawable.M17: DrawableResource by lazy {
      DrawableResource("drawable:M17", setOf(
        ResourceItem(setOf(), "${MD}drawable/M17.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_068_341_025)
internal val Res.drawable.M17A: DrawableResource by lazy {
      DrawableResource("drawable:M17A", setOf(
        ResourceItem(setOf(), "${MD}drawable/M17A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-516_430_488)
internal val Res.drawable.M18: DrawableResource by lazy {
      DrawableResource("drawable:M18", setOf(
        ResourceItem(setOf(), "${MD}drawable/M18.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_725_455_490)
internal val Res.drawable.M19: DrawableResource by lazy {
      DrawableResource("drawable:M19", setOf(
        ResourceItem(setOf(), "${MD}drawable/M19.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(459_816_833)
internal val Res.drawable.M1A: DrawableResource by lazy {
      DrawableResource("drawable:M1A", setOf(
        ResourceItem(setOf(), "${MD}drawable/M1A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-312_353_403)
internal val Res.drawable.M1B: DrawableResource by lazy {
      DrawableResource("drawable:M1B", setOf(
        ResourceItem(setOf(), "${MD}drawable/M1B.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(424_009_398)
internal val Res.drawable.M2: DrawableResource by lazy {
      DrawableResource("drawable:M2", setOf(
        ResourceItem(setOf(), "${MD}drawable/M2.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(631_138_560)
internal val Res.drawable.M20: DrawableResource by lazy {
      DrawableResource("drawable:M20", setOf(
        ResourceItem(setOf(), "${MD}drawable/M20.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_196_151_243)
internal val Res.drawable.M21: DrawableResource by lazy {
      DrawableResource("drawable:M21", setOf(
        ResourceItem(setOf(), "${MD}drawable/M21.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-318_481_013)
internal val Res.drawable.M22: DrawableResource by lazy {
      DrawableResource("drawable:M22", setOf(
        ResourceItem(setOf(), "${MD}drawable/M22.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_826_911_776)
internal val Res.drawable.M22A: DrawableResource by lazy {
      DrawableResource("drawable:M22A", setOf(
        ResourceItem(setOf(), "${MD}drawable/M22A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-749_013_110)
internal val Res.drawable.M23: DrawableResource by lazy {
      DrawableResource("drawable:M23", setOf(
        ResourceItem(setOf(), "${MD}drawable/M23.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_293_601_853)
internal val Res.drawable.M24: DrawableResource by lazy {
      DrawableResource("drawable:M24", setOf(
        ResourceItem(setOf(), "${MD}drawable/M24.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_319_193_834)
internal val Res.drawable.M24A: DrawableResource by lazy {
      DrawableResource("drawable:M24A", setOf(
        ResourceItem(setOf(), "${MD}drawable/M24A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_915_750_857)
internal val Res.drawable.M25: DrawableResource by lazy {
      DrawableResource("drawable:M25", setOf(
        ResourceItem(setOf(), "${MD}drawable/M25.webp", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable4Resources(map: MutableMap<String, DrawableResource>) {
  map.put("G45", Res.drawable.G45)
  map.put("G45A", Res.drawable.G45A)
  map.put("G46", Res.drawable.G46)
  map.put("G47", Res.drawable.G47)
  map.put("G48", Res.drawable.G48)
  map.put("G49", Res.drawable.G49)
  map.put("G5", Res.drawable.G5)
  map.put("G50", Res.drawable.G50)
  map.put("G51", Res.drawable.G51)
  map.put("G52", Res.drawable.G52)
  map.put("G53", Res.drawable.G53)
  map.put("G54", Res.drawable.G54)
  map.put("G6", Res.drawable.G6)
  map.put("G6A", Res.drawable.G6A)
  map.put("G7", Res.drawable.G7)
  map.put("G7A", Res.drawable.G7A)
  map.put("G7B", Res.drawable.G7B)
  map.put("G8", Res.drawable.G8)
  map.put("G9", Res.drawable.G9)
  map.put("H1", Res.drawable.H1)
  map.put("H2", Res.drawable.H2)
  map.put("H3", Res.drawable.H3)
  map.put("H4", Res.drawable.H4)
  map.put("H5", Res.drawable.H5)
  map.put("H6", Res.drawable.H6)
  map.put("H6A", Res.drawable.H6A)
  map.put("H7", Res.drawable.H7)
  map.put("H8", Res.drawable.H8)
  map.put("I1", Res.drawable.I1)
  map.put("I10", Res.drawable.I10)
  map.put("I10A", Res.drawable.I10A)
  map.put("I10X1", Res.drawable.I10X1)
  map.put("I11", Res.drawable.I11)
  map.put("I11A", Res.drawable.I11A)
  map.put("I12", Res.drawable.I12)
  map.put("I13", Res.drawable.I13)
  map.put("I14", Res.drawable.I14)
  map.put("I15", Res.drawable.I15)
  map.put("I2", Res.drawable.I2)
  map.put("I3", Res.drawable.I3)
  map.put("I4", Res.drawable.I4)
  map.put("I5", Res.drawable.I5)
  map.put("I5A", Res.drawable.I5A)
  map.put("I6", Res.drawable.I6)
  map.put("I7", Res.drawable.I7)
  map.put("I8", Res.drawable.I8)
  map.put("I9", Res.drawable.I9)
  map.put("I9A", Res.drawable.I9A)
  map.put("K1", Res.drawable.K1)
  map.put("K2", Res.drawable.K2)
  map.put("K3", Res.drawable.K3)
  map.put("K4", Res.drawable.K4)
  map.put("K5", Res.drawable.K5)
  map.put("K6", Res.drawable.K6)
  map.put("K7", Res.drawable.K7)
  map.put("K8", Res.drawable.K8)
  map.put("L1", Res.drawable.L1)
  map.put("L2", Res.drawable.L2)
  map.put("L2A", Res.drawable.L2A)
  map.put("L3", Res.drawable.L3)
  map.put("L4", Res.drawable.L4)
  map.put("L5", Res.drawable.L5)
  map.put("L6", Res.drawable.L6)
  map.put("L6A", Res.drawable.L6A)
  map.put("L7", Res.drawable.L7)
  map.put("L8", Res.drawable.L8)
  map.put("M1", Res.drawable.M1)
  map.put("M10", Res.drawable.M10)
  map.put("M10A", Res.drawable.M10A)
  map.put("M11", Res.drawable.M11)
  map.put("M12", Res.drawable.M12)
  map.put("M12A", Res.drawable.M12A)
  map.put("M12B", Res.drawable.M12B)
  map.put("M12C", Res.drawable.M12C)
  map.put("M12D", Res.drawable.M12D)
  map.put("M12E", Res.drawable.M12E)
  map.put("M12F", Res.drawable.M12F)
  map.put("M12G", Res.drawable.M12G)
  map.put("M12H", Res.drawable.M12H)
  map.put("M13", Res.drawable.M13)
  map.put("M14", Res.drawable.M14)
  map.put("M15", Res.drawable.M15)
  map.put("M15A", Res.drawable.M15A)
  map.put("M16", Res.drawable.M16)
  map.put("M16A", Res.drawable.M16A)
  map.put("M17", Res.drawable.M17)
  map.put("M17A", Res.drawable.M17A)
  map.put("M18", Res.drawable.M18)
  map.put("M19", Res.drawable.M19)
  map.put("M1A", Res.drawable.M1A)
  map.put("M1B", Res.drawable.M1B)
  map.put("M2", Res.drawable.M2)
  map.put("M20", Res.drawable.M20)
  map.put("M21", Res.drawable.M21)
  map.put("M22", Res.drawable.M22)
  map.put("M22A", Res.drawable.M22A)
  map.put("M23", Res.drawable.M23)
  map.put("M24", Res.drawable.M24)
  map.put("M24A", Res.drawable.M24A)
  map.put("M25", Res.drawable.M25)
}
